module.exports = __webpack_public_path__ + "static/14-052ba2c415c51a9755abbb32c6a933bc.jpg";